<template class="">
  <section>
    <div class="">
      <div class="">
        <div class="">
          <div id="details" class="">
            <div class="d-flex flex-column">
              <label>Location</label><span class="has-danger">*</span>
              <GmapAutocomplete
                name="autocomplete"
                @input.native="handleChange"
                class="locationInput"
                ref="autocomplete"
                :position.sync="markers.position"
                @keyup.enter="usePlace"
                @place_changed="setPlace"
              ></GmapAutocomplete>
            </div>
            <div class="has-danger" v-if="isPlace">
              Location is a required field
            </div>

            <gmap-map
              :center="center"
              :zoom="7"
              map-type-id="terrain"
              style="width: 50%; height: 200px"
            >
              <!-- <GMapPolygon /> -->
              <gmap-marker
                @dragend="updateMaker"
                :key="index"
                :position="markers.position"
                :clickable="true"
                :draggable="true"
                @click="panToMarker"
              ></gmap-marker>
            </gmap-map>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formService, eventBus, transportService } from "../../../services";
import { EVENTS } from "../../../config";
import { USER_ROLES } from "../../../config";
import { mapState } from "vuex";

import VueGoogleAutocomplete from "vue-google-autocomplete";
import { onLog } from "firebase";

export default {
  name: "location",
  components: { VueGoogleAutocomplete },

  data() {
    return {
      isPlace: false,
      // markersss: {
      //     position: {
      //         lat: 11,
      //         lng: 10
      //     }
      // },
      markers: {
        position: { lat: 11, lng: 10 },
      },
      //             paths: [
      //     { lat: 25.774, lng: -80.19 },
      //     { lat: 18.466, lng: -66.118 },
      //     { lat: 32.321, lng: -64.757 },
      //   ],
      center: {
        lat: 11,
        lng: 10,
      },
      mapOptions: {
        disableDefaultUI: true,
      },
      geoLocation: {},
      // currentPlace:null,
      // ready: false,
      // USER_ROLES: USER_ROLES,
      // loading: false,
      // flash: false,
      // flashType: null,
      // flashMessage: '',
      // EVENTS: EVENTS,
      // formstate: {},
      // transport: {},
      // oldTransport: {},
      // transportId: [],
      // userId: this.$route.params._id,
    };
  },
  // mounted: function() {
  //     this.getRegionList()
  // },
  mounted() {
    this.geolocate();
    eventBus.$on("getgeoLocation", (locationInfo) => {
      this.$refs.autocomplete.$refs.input.value = locationInfo.name;
      this.markers.position["lat"] = locationInfo.lat;
      this.markers.position["lng"] = locationInfo.long;

      let getPostion = {
        lat: locationInfo.lat,
        lng: locationInfo.long,
      };
      this.markers = { position: getPostion };
    });

    // let autocomplete = new google.maps.places.Autocomplete(
    //     // document.getElementById("autocomplete")
    //     this.$refs["autocomplete"], {
    //         bounds: new google.maps.LatLngBounds(
    //             new google.maps.LatLng(45.4215296, -756971931)
    //         )
    //     }
    // );
    // autocomplete.addListener("place_changed", () => {
    //     let place = autocomplete.getPlace();
    //     this.showTransportLocationOnMap(place.geometry.location.let(), place.geometry.location.lng())
    // });
  },

  methods: {
    fieldClassName: formService.fieldClassName,
    setPlace(place) {
      this.isPlace = false;
      this.currentPlace = place;
      const marker = {
        lat: this.currentPlace.geometry.location.lat(),
        lng: this.currentPlace.geometry.location.lng(),
      };
      this.markers = { position: marker };
      this.center = marker;
      this.currentPlace = null;
      this.geoLocation["lat"] = this.markers.position.lng;
      this.geoLocation["lng"] = this.markers.position.lat;
      this.geoLocation["name"] = place.formatted_address;
      eventBus.$emit("geoLocation", this.geoLocation);
      // this.$emit('changeEvent');
      this.$listeners["change-event"](true);
    },
    handleChange(event) {
      if (event.target.value) {
        this.$listeners["change-event"](false);
        this.isPlace = true;
      }
    },

    usePlace(place) {
      if (place) {
        var newPostion = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        this.center = newPostion;
        this.markers.position = newPostion;
        this.place = null;
      }
    },

    updateMaker: function(event) {
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ latLng: event.latLng }, (result, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          // accessing autocomplete reference and populating the address
          this.$refs.autocomplete.$refs.input.value =
            result[0].formatted_address;
          // let lat = result[0].geometry.location.lat()
          // let long = result[0].geometry.location.lng()
          this.geoLocation["lat"] = result[0].geometry.location.lat();
          this.geoLocation["lng"] = result[0].geometry.location.lng();
          this.geoLocation["name"] = result[0].formatted_address;
          eventBus.$emit("geoLocation", this.geoLocation);
        }
      });
    },

    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        // this.panToMarker();
      });
    },
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
    },
    //Moves the map view port to marker
    panToMarker() {
      this.$refs.mapRef.panTo(this.marker.position);
      this.$refs.mapRef.setZoom(18);
    },
    //Moves the marker to click position on the map
    handleMapClick(e) {
      this.marker.position = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
    },
    showTransportLocationOnMap(latitude, longitude) {
      let map = new google.maps.Map(document.getElementById("Map"), {
        zoom: 15,
        center: new google.maps.LatLng(latitude, longitude),
        mapTypeId: google.maps.mapTypeId.ROADMAP,
      });
      new google.maps.Marker({
        position: new google.maps.LatLng(latitude, longitude),
        map: map,
      });
    },

    locatorButtonPressed() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude);

            this.showTransportLocationOnMap(
              position.coords.latitude,
              position.coords.longitude
            );
          },
          (error) => {}
        );
      } else {
        this.error = error.message;
      }
    },
  },

  created() {},

  fieldClassName: function(field) {
    if (!field) {
      return "";
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return "has-success";
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return "has-danger";
    }
  },

  // computed: {
  //     ...mapState({
  //         user: state => state.auth.user,
  //     })
  // }
};
</script>

<style scoped>
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.has-danger {
  color: red;
}

.mt {
  margin-top: 7px;
}

.gradientbt {
  background: #35A2FE;
  color: white;
}

.inputwrapper {
  position: relative;
}

.maps {
  position: absolute;
  top: 7px;
  right: 10px;
}

.locationInput {
  display: block;
  /* height: 34px; */
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  width: 100%;
  margin-bottom: 10px;
}

/* .locationInput input:focus-visible {
    outline: none;
} */
</style>



// WEBPACK FOOTER //
// location.vue?2d392f26